import { object, string } from 'yup';

import { FIELD_IS_REQUIRED, INVALID_EMAIL } from '@/constants';

export const recoverSchema = object({
  email: string()
    .required(FIELD_IS_REQUIRED)
    .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]+$/gim, INVALID_EMAIL),
});
